import { style } from 'typestyle'
export const mt80 = style({ marginTop: '80px' })
